import { SpinnerProps, Overlay, Spinner } from "@blueprintjs/core"
import React from "react"

export type CustomSpinnerProps = SpinnerProps & {
  // Insert any extra props here
  /**
   * the isOpen field for the overlay
   * @default true
   */
  isOpen?: boolean
  autoFocus?: boolean
  enforceFocus?: boolean
}
const CustomSpinner = ({
  className,
  intent,
  size,
  value,
  tagName,
  autoFocus,
  enforceFocus,
  isOpen,
}: CustomSpinnerProps) => {
  return (
    <Overlay
      className="vt-spinner-overlay"
      isOpen={isOpen}
      autoFocus={autoFocus}
      enforceFocus={enforceFocus}
    >
      <div className="vt-spinner-wrapper">
        <Spinner
          className={className}
          intent={intent}
          size={size}
          value={value}
          tagName={tagName}
        />
      </div>
    </Overlay>
  )
}
CustomSpinner.defaultProps = {
  isOpen: true,
  autoFocus: false,
  enforceFocus: false,
}
export default CustomSpinner
